import { z } from "zod";

// GET Request Schemas //
//Endpoint: /api/create-quote/getHolidays?returnFutureHolidays={:booleanFlag}
export const holidaySchema = z.object({
	id: z.number(),
	holidayName: z.string(),
	holidayDate: z.string(), //TODO: investigate why we are inserting a Date as a string to DB
	isCanadian: z.boolean(),
	isUSA: z.boolean(),
	isTQL: z.boolean(),
});

export type Holiday = z.infer<typeof holidaySchema>;
